

import Vue from 'vue'
import VueRouter from 'vue-router'
import location00 from '../views/location00.vue'
import location01 from '../views/location01.vue'
import location02 from '../views/location02.vue'
import location03 from '../views/location03.vue'
import location04 from '../views/location04.vue'
import location05 from '../views/location05.vue'
import location06 from '../views/location06.vue'
import location07 from '../views/location07.vue'

import location0111 from '../views/location0111.vue'
import location0112 from '../views/location0112.vue'
import location0121 from '../views/location0121.vue'
import location0122 from '../views/location0122.vue'



import location0211 from '../views/location0211.vue'
import location0221 from '../views/location0221.vue'
import location0222 from '../views/location0222.vue'
import location0231 from '../views/location0231.vue'
import location0232 from '../views/location0232.vue'
import location0241 from '../views/location0241.vue'

import location0311 from '../views/location0311.vue'
import location0321 from '../views/location0321.vue'
import location0331 from '../views/location0331.vue'

import location0411 from '../views/location0411.vue'
import location0421 from '../views/location0421.vue'
import location0422 from '../views/location0422.vue'
import location0430 from '../views/location0430.vue'
import location0431 from '../views/location0431.vue'
import location0432 from '../views/location0432.vue'
import location0433 from '../views/location0433.vue'
import location0434 from '../views/location0434.vue'
import location0435 from '../views/location0435.vue'
import location0436 from '../views/location0436.vue'
import location0437 from '../views/location0437.vue'
import location0441 from '../views/location0441.vue'
import location0451 from '../views/location0451.vue'
import location0452 from '../views/location0452.vue'
import location0461 from '../views/location0461.vue'
import location0462 from '../views/location0462.vue'
import location0471 from '../views/location0471.vue'
import location0481 from '../views/location0481.vue'





import location0511 from '../views/location0511.vue'
import location0521 from '../views/location0521.vue'
import location0522 from '../views/location0522.vue'
import location0523 from '../views/location0523.vue'
import location0531 from '../views/location0531.vue'

import location0611 from '../views/location0611.vue'
import location0621 from '../views/location0621.vue'
import location0622 from '../views/location0622.vue'
import location0631 from '../views/location0631.vue'

import location0711 from '../views/location0711.vue'
import location0721 from '../views/location0721.vue'
import location0722 from '../views/location0722.vue'



Vue.use(VueRouter)




const routes = [





  { 
    path: '/', 
    component:location00,
  },
  { 
    path: '/location00', 
    component:location00,
  },
  { 
    path: '/location01', 
    component:location01,
  },
  { 
    path: '/location02',
    component:location02,
  },
  { 
    path: '/location03',
    component:location03,
  },
  { 
    path: '/location04',
    component:location04,
  },
  { 
    path: '/location05',
    component:location05,
  },
  { 
    path: '/location06',
    component:location06,
  },
  { 
    path: '/location07',
    component:location07,
  },
  { 
    path: '/location0111',
    component:location0111,
  },
  { 
    path: '/location0112',
    component:location0112,
  },
  { 
    path: '/location0121',
    component:location0121,
  },
  { 
    path: '/location0122',
    component:location0122,
  },
  { 
    path: '/location0211',
    component:location0211,
  },
  { 
    path: '/location0221',
    component:location0221,
  },
  { 
    path: '/location0222',
    component:location0222,
  },
  { 
    path: '/location0231',
    component:location0231,
  },
  { 
    path: '/location0232',
    component:location0232,
  },
  { 
    path: '/location0241',
    component:location0241,
  },

  { 
    path: '/location0311',
    component:location0311,
  },
  { 
    path: '/location0321',
    component:location0321,
  },
  { 
    path: '/location0331',
    component:location0331,
  },


  { 
    path: '/location0411',
    component:location0411,
  },
  { 
    path: '/location0421',
    component:location0421,
  },
  { 
    path: '/location0422',
    component:location0422,
  },
  { 
    path: '/location0430',
    component:location0430,
  },
  { 
    path: '/location0431',
    component:location0431,
  },
  { 
    path: '/location0432',
    component:location0432,
  },
  { 
    path: '/location0433',
    component:location0433,
  },
  { 
    path: '/location0434',
    component:location0434,
  },
  { 
    path: '/location0435',
    component:location0435,
  },
  { 
    path: '/location0436',
    component:location0436,
  },
  { 
    path: '/location0437',
    component:location0437,
  },
  { 
    path: '/location0441',
    component:location0441,
  },
  { 
    path: '/location0451',
    component:location0451,
  },
  { 
    path: '/location0452',
    component:location0452,
  },
  { 
    path: '/location0461',
    component:location0461,
  },
  { 
    path: '/location0462',
    component:location0462,
  },
  { 
    path: '/location0471',
    component:location0471,
  },
  { 
    path: '/location0481',
    component:location0481,
  },



  { 
    path: '/location0511',
    component:location0511,
  },
  { 
    path: '/location0521',
    component:location0521,
  },
  { 
    path: '/location0522',
    component:location0522,
  },
  { 
    path: '/location0523',
    component:location0523,
  },
  { 
    path: '/location0531',
    component:location0531,
  },
  { 
    path: '/location0611',
    component:location0611,
  },
  { 
    path: '/location0621',
    component:location0621,
  },
  { 
    path: '/location0622',
    component:location0622,
  },
  { 
    path: '/location0631',
    component:location0631,
  },
  
  { 
    path: '/location0711',
    component:location0711,
  },
  { 
    path: '/location0721',
    component:location0721,
  },
  { 
    path: '/location0722',
    component:location0722,
  },
 
  /*錯誤跳轉回家*/
  {
    path: '*',
    redirect: '/',
  }


  
]





const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes

})

/*
router.beforeEach((to, from, next)=>{
  const isLogin = localStorage.getItem('token') == 'ImLogin' ;
  if( isLogin ){
    next();
  } else {
    if( to.path !== '/login')
      next('/login');
    else
      next();
  }
});
*/

export default router
